var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CardBodyItem", {
    attrs: { label: _vm.label },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ textClasses }) {
          return [
            _c(
              "RouterLink",
              {
                staticClass: "text-primary hover:text-primary-600",
                class: textClasses,
                attrs: { to: _vm.routeLink },
              },
              [_vm._v(" " + _vm._s(_vm.value) + " ")]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }